import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const fetchWasteCodes = createAsyncThunk(
    'wasteCode/fetchWasteCodes',
    async(_, { dispatch }) => {
        try{
            const request = await axios.get(`/api/wastecode/showall`, getAuthHeader());
            return request.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
)